import { createApplicationState } from '../applicationState';
import { renderApplication } from '../renderApplication';
import { createContext } from './createContext';
import '@cian/ui-kit-design-tokens/colors/semanticPalette.css';
import '../../css/fonts.css';
import '../../css/colors.css';
import '../../css/froala.css';
import '../../css/banners.css';
import '../../css/post-card-banner-standard-four.css';
import '../../css/post-card-expert-block.css';
import '../../css/post-card-statistics.css';
import '../../css/post-card-table-of-content.css';
import '../../css/post-card-tables.css';
import '../../css/quill.css';
import '../../css/vk-video.css';
import '@splidejs/react-splide/css/core';

export function runApp() {
  const context = createContext();

  const store = createApplicationState(context);

  renderApplication({ context, store });
}
